export default __webpack_public_path__ + "static/media/colorpal.15406dd9.jpg";